<template>
    <section class="c-feature">
        <ul class="feature-grid">
            <li
                v-for="(item, i) in albums"
                :key="i"
                class="feature-grid__item"
            >
                <div class="feature-item">
                    <div
                        v-if="item.title"
                        class="feature-item__header"
                    >
                        <h2
                            class="item-title"
                            v-text="item.title"
                        />
                        <div class="item-icon">
                            <img
                                :src="imgSrc(item)"
                                :alt="item.title"
                                class="icon-img"
                            >
                        </div>
                    </div>
                    <div
                        v-if="item.description"
                        class="feature-item__description"
                        v-text="item.description"
                    />
                    <router-link
                        v-if="item.hyperlink"
                        :to="item.hyperlink"
                        class="feature-item__link"
                    >
                        <span v-text="$t('buttons.learn_more')" />
                        <img
                            src="@/assets/images/arrow_forward.svg"
                            :alt="item.title"
                            class="link-img"
                        >
                    </router-link>
                </div>
            </li>
        </ul>
    </section>
</template>

<script >

    export default {
        name: 'ForPagesFeature',

        /**
         *
         * @inheritDoc
         */
        props: {
            albums: {
                type    : Array,
                required: true,
            },
        },
    };

</script>

<style lang="scss" src="./feature.scss"/>
